import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import irelandApi from '../irelandApi';
import store from '../store';
import ToastMessage from '../components/common/toast-message';
import { prepareMarketingCategoriesAttributes } from './about-you';
import {
  UPDATE_MY_PROFILE_EMAIL_FULFILLED,
  UPDATE_MY_PROFILE_EMAIL_PENDING,
  UPDATE_MY_PROFILE_EMAIL_REJECTED
} from '../reducers/userReducer';

export const getCurrentUser = () => (dispatch) => {
  dispatch({type: 'GET_CURRENT_USER_PENDING', payload: []});
  return irelandApi.get('/api/current_user')
    .then((response) => {
      dispatch({type: 'GET_CURRENT_USER_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_CURRENT_USER_REJECTED', payLoad: error.data});

      Promise.reject(error);
    });
};

export const getMyProfile = (action = 'GET_PROFILE') => (dispatch) => {
  dispatch({type: `${action}_PENDING`, payload: []});

  return irelandApi.get('/api/users/my_profile')
    .then((response) => {
      const { attributes } = response.data.data;

      dispatch({ type: `${action}_FULFILLED`, payLoad: response.data });
      dispatch({ type: 'TOGGLE_PRIVACY_MODAL', payLoad: !attributes['privacy-policy-accepted'] });
      dispatch({ type: 'TOGGLE_MARKETING_MODAL', payLoad: attributes['marketing-accepted'] == null });
      dispatch({
        type: 'GET_UNREAD_MESSAGE_COUNT',
        payLoad: {
          unread_messages: response.data.meta['unread-messages']
        }
      });

      if (attributes['should-opt-in']) {
        dispatch({ type: 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG', payLoad: true });
      }
    })
    .catch((error) => {
      // Added because of #1153. Received the error below when PPC popup is shown.
      // The error comes from react-bootstrap's Modal.
      if (!(error instanceof TypeError &&
        (error.message === "Cannot read property 'window' of null" || error.message === 'node is null'))) {
        dispatch({ type: `${action}__REJECTED`, payLoad: error.data });
        Promise.reject(error);
      }
    });
};

export const getAdminMyProfile = (action = 'GET_PROFILE') => (dispatch) => {
  dispatch({type: `${action}_PENDING`, payload: []});

  return irelandApi.get('/api/admin/users/my_profile')
    .then((response) => {
      dispatch({type: `${action}_FULFILLED`, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: `${action}__REJECTED`, payLoad: error.data});
    });
};

export const saveMyProfile = (payLoad, password) => {
  const formData = new FormData();
  const newPayload = prepareMarketingCategoriesAttributes(payLoad);

  Object.keys(newPayload).forEach((key) => {
    if ([
      'personal_address_1',
      'personal_address_2',
      'personal_address_3',
      'personal_address_4',
      'personaL_eircode',
      'should_opt_in',
      'has_ignite_gold_outlet'
    ].indexOf(key) > -1) {
      return;
    }

    if (newPayload[key] === undefined) {
      formData.append(`my_profile[${key}]`, '');
    } else if (key === 'marketing_categories_users_attributes') {
      newPayload[key].forEach((item) => {
        formData.append(`my_profile[${key}][][accepted]`, item.accepted);
        formData.append(`my_profile[${key}][][marketing_category_id]`, item.marketing_category_id);
      });
    } else {
      formData.append(`my_profile[${key}]`, newPayload[key]);
    }
  });

  if (password) {
    formData.append('user[password]', password);
  }

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  return irelandApi.patch('/api/users/my_profile', formData, config)
    .then(() => {
      store.dispatch(actions.resetValidity('deep.my_profile'));
      toast.success(<ToastMessage iconStyle="success" message="Profile saved successfully"/>);
    })
    .catch((error) => {
      let errorMessage = 'An error occurred during save';

      if (error && error.response && error.response.data) {
        errorMessage = error.response.data.message;
      }

      toast.error(<ToastMessage iconStyle="error" message={errorMessage}/>);
      store.dispatch(actions.resetValidity('deep.my_profile'));

      const data = {
        ...error.response.data.errors
      };

      return Promise.reject(data);
    });
};

export const saveAdminMyProfile = (payLoad, password) => {
  const data = { my_profile: payLoad };

  if (password) {
    data.user = { password };
  }

  return irelandApi.patch('/api/admin/users/my_profile', data)
    .then(() => {
      store.dispatch(actions.resetValidity('deep.admin_my_profile'));
      toast.success(<ToastMessage iconStyle="success" message="Profile saved successfully" />);
    })
    .catch((error) => {
      let errorMessage = 'An error occurred during save';

      if (error && error.response && error.response.data) {
        errorMessage = error.response.data.message;
      }

      toast.error(<ToastMessage iconStyle="error" message={errorMessage} />);
      store.dispatch(actions.resetValidity('deep.admin_my_profile'));

      const errorData = {
        ...error.response.data.errors
      };

      return Promise.reject(errorData);
    });
};

export const updateMyProfileEmail = (payload, isAdmin) => (dispatch) => {
  dispatch({ type: UPDATE_MY_PROFILE_EMAIL_PENDING });

  const path = `/api/${isAdmin ? 'admin/' : ''}users/update_email`;
  const data = { user: { email_change_token: payload } };

  return irelandApi.patch(path, data)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Email updated successfully"/>);
      dispatch({ type: UPDATE_MY_PROFILE_EMAIL_FULFILLED, payLoad: response.data });
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Invalid token" />);
      dispatch({ type: UPDATE_MY_PROFILE_EMAIL_REJECTED, payLoad: error.data });
    });
};

export const closeAccount = () =>
  irelandApi.delete('/api/users')
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Account suspended, redirecting to login..."/>);
      store.dispatch({type: 'DELETE_ACCOUNT_SUCCESS'});
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });

export const acceptPrivacy = () => dispatch => irelandApi.patch('/api/users/accept_privacy_policy')
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="You have accepted our privacy policy"/>);
    dispatch({type: 'TOGGLE_PRIVACY_MODAL', payLoad: false});
    window.location.reload(false);
  })
  .catch((error) => {
    // Added because of #1229. Received the error below when PPC popup is shown.
    // The error comes from react-bootstrap's Modal.
    if (!(error instanceof TypeError && error.message === "Cannot read property 'window' of null")) {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred."/>);
      Promise.reject(error);
    }
  });
